import styles from "../../../styles.module.scss";

import { createColumn } from "../utils";
import { MergedColumnType } from "../../types";
//UI
import type { ColumnType } from "antd/es/table";
import Checkbox from "antd/lib/checkbox";

export const configuringPageAccessColumns = (
  intl: (id: string) => string,
  getColumnSearchProps?: (
    dataIndex: keyof MergedColumnType
  ) => ColumnType<MergedColumnType>,
  filters?: { text: string; value: boolean }[],
  data?: MergedColumnType[]
) => [
  createColumn(
    intl("role"),
    "Role",
    350,
    undefined,
    (a, b) => a.Role?.localeCompare(b.Role),
    undefined,
    true,
    data
  ),
  createColumn(
    intl("namegroup"),
    "GroupPages",
    350,
    undefined,
    (a, b) => a.GroupPages?.localeCompare(b.GroupPages),
    undefined,
    true,
    data
  ),
  createColumn(
    intl("pages"),
    "Pages",
    undefined,
    undefined,
    (a, b) => a.Pages?.localeCompare(b.Pages),
    undefined,
    true,
    data
  ),
  {
    title: intl("access"),
    dataIndex: "Access",
    key: "Access",
    align: "center" as const,
    width: 200,
    ellipsis: true,
    render: (_: any, record: MergedColumnType) => (
      <Checkbox
        className={styles["checkbox"]}
        checked={!!record.Access}
        disabled
      />
    ),
    filters,
    onFilter: (value: any, record: MergedColumnType) =>
      !!record.Access === value,
  },
];

export const buttonAccessSettingsColumns = (
  intl: (id: string) => string,
  getColumnSearchProps?: (
    dataIndex: keyof MergedColumnType
  ) => ColumnType<MergedColumnType>,
  filters?: { text: string; value: boolean }[],
  data?: MergedColumnType[]
) => [
  createColumn(
    intl("role"),
    "Role",
    350,
    undefined,
    (a, b) => a.Role?.localeCompare(b.Role),
    undefined,
    true,
    data
  ),
  createColumn(
    intl("namegroup"),
    "GroupPages",
    350,
    undefined,
    (a, b) => a.GroupPages?.localeCompare(b.GroupPages),
    undefined,
    true,
    data
  ),
  createColumn(
    intl("pages"),
    "Pages",
    undefined,
    undefined,
    (a, b) => a.Pages?.localeCompare(b.Pages),
    undefined,
    true,
    data
  ),
  createColumn(
    intl("buttons"),
    "Buttons",
    undefined,
    undefined,
    (a, b) => a.Buttons?.localeCompare(b.Buttons),
    undefined,
    true,
    data
  ),
  {
    title: intl("access"),
    dataIndex: "Access",
    key: "Access",
    align: "center" as const,
    width: 150,
    ellipsis: true,
    render: (_: any, record: MergedColumnType) => (
      <Checkbox
        className={styles["checkbox"]}
        checked={!!record.Access}
        disabled
      />
    ),
    filters,
    onFilter: (value: any, record: MergedColumnType) =>
      !!record.Access === value,
  },
];

export const serverSettingsColumns = (
  intl: (id: string) => string,
  getColumnSearchProps?: (
    dataIndex: keyof MergedColumnType
  ) => ColumnType<MergedColumnType>,
  filters?: { text: string; value: boolean }[],
  data?: MergedColumnType[]
) => [
  createColumn(
    intl("servername"),
    "ServerName",
    undefined,
    undefined,
    (a, b) => a.ServerName?.localeCompare(b.ServerName),
    undefined,
    true,
    data
  ),
  createColumn(
    intl("servercode"),
    "ServerCode",
    undefined,
    undefined,
    (a, b) => a.ServerCode?.localeCompare(b.ServerCode),
    undefined,
    true,
    data
  ),
  createColumn(
    intl("imap-address"),
    "Imap_host",
    undefined,
    undefined,
    (a, b) => a.Imap_host?.localeCompare(b.Imap_host),
    undefined,
    true,
    data
  ),
  createColumn(
    intl("imap-port"),
    "Imap_port",
    undefined,
    undefined,
    (a, b) => a.Imap_port?.localeCompare(b.Imap_port),
    undefined,
    true,
    data
  ),
  createColumn(
    intl("imap-connection-security"),
    "name_ss_options_imap",
    undefined,
    undefined,
    (a, b) => a.name_ss_options_imap?.localeCompare(b.name_ss_options_imap),
    undefined,
    true,
    data
  ),
  createColumn(
    intl("smtp-address"),
    "smtp_host",
    undefined,
    undefined,
    (a, b) => a.smtp_host?.localeCompare(b.smtp_host),
    undefined,
    true,
    data
  ),
  createColumn(
    intl("smtp-port"),
    "smtp_port",
    undefined,
    undefined,
    (a, b) => a.smtp_port?.localeCompare(b.smtp_port),
    undefined,
    true,
    data
  ),
  createColumn(
    intl("smtp-connection-security"),
    "name_ss_options_smtp",
    undefined,
    undefined,
    (a, b) => a.name_ss_options_smtp?.localeCompare(b.name_ss_options_smtp),
    undefined,
    true,
    data
  ),
  {
    title: intl("smtp-authorization"),
    dataIndex: "smtp_Auth",
    key: "smtp_Auth",
    align: "center" as const,
    width: 100,
    ellipsis: true,
    render: (_: any, record: MergedColumnType) => (
      <Checkbox
        className={styles["checkbox"]}
        checked={!!record.smtp_Auth}
        disabled
      />
    ),
    filters,
    onFilter: (value: any, record: MergedColumnType) =>
      !!record.smtp_Auth === value,
  },
];

export const usersColumns = (
  intl: (id: string) => string,
  getColumnSearchProps?: (
    dataIndex: keyof MergedColumnType
  ) => ColumnType<MergedColumnType>,
  filters?: { text: string; value: boolean }[]
) => [
  createColumn(
    intl("login-email"),
    "email",
    200,
    getColumnSearchProps,
    (a, b) => a.email?.localeCompare(b.email)
  ),
  createColumn(
    intl("last-name"),
    "LastName",
    180,
    getColumnSearchProps,
    (a, b) => a.LastName?.localeCompare(b.LastName)
  ),
  createColumn(
    intl("first-name"),
    "FirstName",
    180,
    getColumnSearchProps,
    (a, b) => a.FirstName?.localeCompare(b.FirstName)
  ),
  createColumn(
    intl("middle-name"),
    "MiddleName",
    180,
    getColumnSearchProps,
    (a, b) => a.MiddleName?.localeCompare(b.MiddleName)
  ),
  createColumn(
    intl("sed-user"),
    "UserName",
    250,
    getColumnSearchProps,
    (a, b) => a.UserName?.localeCompare(b.UserName)
  ),
  createColumn(
    intl("role"),
    "Name_prav",
    130,
    getColumnSearchProps,
    (a, b) => a.Name_prav?.localeCompare(b.Name_prav)
  ),
  {
    title: intl("access"),
    dataIndex: "del",
    key: "del",
    align: "center" as const,
    width: 100,
    ellipsis: true,
    render: (_: any, record: MergedColumnType) => (
      <Checkbox
        className={styles["checkbox"]}
        checked={!!record.del}
        disabled
      />
    ),
    filters,
    onFilter: (value: any, record: MergedColumnType) => !!record.del === value,
  },
  {
    title: intl("deleted"),
    dataIndex: "isDelUser",
    key: "isDelUser",
    align: "center" as const,
    width: 100,
    ellipsis: true,
    render: (_: any, record: MergedColumnType) => (
      <Checkbox
        className={styles["checkbox"]}
        checked={!!record.isDelUser}
        disabled
      />
    ),
    filters,
    onFilter: (value: any, record: MergedColumnType) =>
      !!record.isDelUser === value,
  },
];

export const documentDisplayOptionsColumns = (
  intl: (id: string) => string,
  getColumnSearchProps?: (
    dataIndex: keyof MergedColumnType
  ) => ColumnType<MergedColumnType>,
  filters?: { text: string; value: boolean }[],
  data?: MergedColumnType[]
) => [
  createColumn(
    intl("parameters"),
    "NameTypeRec",
    200,
    getColumnSearchProps,
    (a, b) => a.NameTypeRec?.localeCompare(b.NameTypeRec)
  ),
];

export const documentDisplayOptionsAccessColumns = (
  intl: (id: string) => string,
  getColumnSearchProps?: (
    dataIndex: keyof MergedColumnType
  ) => ColumnType<MergedColumnType>,
  filters?: { text: string; value: boolean }[],
  data?: MergedColumnType[],
  visible?: boolean,
  onChange?: (id: number, e: boolean) => Promise<void>
) => [
  {
    title: intl("access"),
    dataIndex: "Value",
    key: "Value",
    align: "center" as const,
    width: 100,
    ellipsis: true,
    render: (_: any, record: MergedColumnType) => (
      <Checkbox
        className={styles["checkbox"]}
        checked={!!record.Value}
        onChange={(e) => onChange?.(record.id, e.target.checked)}
        // disabled
      />
    ),
    filters,
    onFilter: (value: any, record: MergedColumnType) =>
      !!record.isDelUser === value,
  },
  createColumn(intl("role"), "Name", undefined, getColumnSearchProps, (a, b) =>
    a.Name?.localeCompare(b.Name)
  ),
];

export const barcodeApplicationOptionsColumns = (
  intl: (id: string) => string,
  getColumnSearchProps?: (
    dataIndex: keyof MergedColumnType
  ) => ColumnType<MergedColumnType>,
  filters?: { text: string; value: boolean }[]
) => [
  createColumn(
    intl("document-type"),
    "name_const_typeDoc",
    200,
    getColumnSearchProps,
    (a, b) => a.name_const_typeDoc?.localeCompare(b.name_const_typeDoc)
  ),
  createColumn(
    intl("department"),
    "name_otdel",
    300,
    getColumnSearchProps,
    (a, b) => a.name_otdel?.localeCompare(b.name_otdel)
  ),
  createColumn(
    intl("arrangement"),
    "name_placement",
    150,
    getColumnSearchProps,
    (a, b) => a.name_placement?.localeCompare(b.name_placement)
  ),
  createColumn(
    intl("height"),
    "Height",
    100,
    getColumnSearchProps,
    (a, b) => a.Height - b.Height
  ),
  createColumn(
    intl("width"),
    "Width",
    110,
    getColumnSearchProps,
    (a, b) => a.Width - b.Width
  ),
  // createColumn(
  //   intl("barcode-height"),
  //   "barcodeHeight",
  //   100,
  //   getColumnSearchProps,
  //   (a, b) => a.barcodeHeight - b.barcodeHeight
  // ),
  createColumn(
    intl("image-format"),
    "image_format",
    200,
    getColumnSearchProps,
    (a, b) => a.image_format?.localeCompare(b.image_format)
  ),
  createColumn(
    intl("font"),
    "font_size",
    100,
    getColumnSearchProps,
    (a, b) => a.font_size - b.font_size
  ),
  {
    title: intl("with-a-digital-value"),
    dataIndex: "isShowDataCode",
    key: "isShowDataCode",
    align: "center" as const,
    width: 130,
    ellipsis: true,
    render: (_: any, record: MergedColumnType) => (
      <Checkbox
        className={styles["checkbox"]}
        checked={!!record.isShowDataCode}
        disabled
      />
    ),
    filters,
    onFilter: (value: any, record: MergedColumnType) =>
      !!record.isShowDataCode === value,
  },
  {
    title: intl("add-when-signing"),
    dataIndex: "isInsertInSignInfo",
    key: "isInsertInSignInfo",
    align: "center" as const,
    width: 120,
    ellipsis: true,
    render: (_: any, record: MergedColumnType) => (
      <Checkbox
        className={styles["checkbox"]}
        checked={!!record.isInsertInSignInfo}
        disabled
      />
    ),
    filters,
    onFilter: (value: any, record: MergedColumnType) =>
      !!record.isInsertInSignInfo === value,
  },
  createColumn(intl("user"), "name_user", 200, getColumnSearchProps, (a, b) =>
    a.name_user?.localeCompare(b.name_user)
  ),
];

export const mailboxesColumns = (
  intl: (id: string) => string,
  getColumnSearchProps?: (
    dataIndex: keyof MergedColumnType
  ) => ColumnType<MergedColumnType>,
  filters?: { text: string; value: boolean }[],
  data?: MergedColumnType[]
) => [
  createColumn(
    intl("server"),
    "ServerName",
    undefined,
    undefined,
    (a, b) => a.ServerName?.localeCompare(b.ServerName),
    undefined,
    true,
    data
  ),
  createColumn(
    intl("mailboxe"),
    "email",
    undefined,
    undefined,
    (a, b) => a.email?.localeCompare(b.email),
    undefined,
    true,
    data
  ),
  createColumn(
    intl("incoming-mail-user-imap"),
    "Imap_user",
    undefined,
    undefined,
    (a, b) => a.Imap_user?.localeCompare(b.Imap_user),
    undefined,
    true,
    data
  ),
  createColumn(
    intl("outgoing-mail-user-smtp"),
    "smtp_user",
    undefined,
    undefined,
    (a, b) => a.smtp_user?.localeCompare(b.smtp_user),
    undefined,
    true,
    data
  ),
];

export const mailboxesByUserColumns = (
  intl: (id: string) => string,
  getColumnSearchProps?: (
    dataIndex: keyof MergedColumnType
  ) => ColumnType<MergedColumnType>,
  filters?: { text: string; value: boolean }[],
  data?: MergedColumnType[]
) => [
  createColumn(
    intl("server"),
    "ServerName",
    undefined,
    undefined,
    (a, b) => a.ServerName?.localeCompare(b.ServerName),
    undefined,
    true,
    data
  ),
  createColumn(
    intl("mailboxe"),
    "email",
    undefined,
    undefined,
    (a, b) => a.email?.localeCompare(b.email),
    undefined,
    true,
    data
  ),
  createColumn(
    intl("mail-user"),
    "name_user_mail",
    undefined,
    undefined,
    (a, b) => a.name_user_mail?.localeCompare(b.name_user_mail),
    undefined,
    true,
    data
  ),
];
